/** Global action that resets all Redux state (used on logout) */
export const LOGOUT_ACTION = 'LOGOUT' as const

export enum Reducers {
  ACCUMULATED_FORMS = 'accumulatedForms',
  CURREN_USER = 'currentUser',
  DASHBOARDS = 'dashboards',
  MODALS = 'modals',
  OBJECT_ENTITIES = 'objectEntities',
  OBJECT_SECURITIES = 'objectSecurities',
  RELATED_FORMS = 'relatedForms',
  RISK_TEMPLATES = 'riskTemplates',
  RISK_VIEWS = 'riskViews',
  SECURITY_PROFILES = 'securityProfiles',
  PUBLIC_FORMS = 'publicForms',
  OFFLINE_RISK = 'offlineRisk',
  TWO_FACTOR_AUTH = 'twoFactorAuth'
}
